import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import ResponsiveTable from "../../components/ResponsiveTable";
import Modal from "../../components/Modal";
import { EyeIcon, PencilIcon, TrashIcon, CurrencyDollarIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import moment from "moment"

export default function SupplierList() {
    const navigate = useNavigate();
    const [customersList, setCustomersList] = useState([])
    const [paymentList, setPaymentList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const getSupplierData = () => {
        axios.get("/suppliers").then((res) => {
            setCustomersList(res.data);
        });
    }
    useEffect(() => {
        getSupplierData()
    }, []);
    const capitalizeFirstLetter = (word) => {
        if (!word || typeof word !== "string") return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
    };
    const getPaymentList = (supplierId) => {
        axios.get(`/suppliers/${supplierId}/payment-history`)
            .then(res => {
                console.log('Payment History:', res.data);
                setPaymentList(res.data?.payment_history ?? [])
            })
            .catch(err => console.error(err));
    }
    const actions = [
        { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'View Payments', value: 'payment', icon: <CurrencyDollarIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
    ];
    const handleActionClick = (action, row) => {
        switch (action) {
            case "edit":
                navigate(`/suppliers/edit/${row.id}`);
                break;
            case "payment":
                getPaymentList(row.id)
                setIsModalOpen(true)
                break;
            case "delete":
                if (window.confirm("Are you sure you want to delete this supplier?")) {
                    axios.delete(`/suppliers/${row.id}`).then(() => {
                        getSupplierData()
                    });
                }
                break;
            default:
                break;
        }
    };
    const handleDownload = (type) => {
        const url = `${apiBaseUrl}/suppliers/export/${type}`;
        window.open(url, "_blank");
    };
    const columns = [
        { header: "SL", accessor: "sl", render: (v, row, i) => i + 1 },
        {
            header: "Created Date", accessor: "expense_date",
            render: (value, row) => <span>{moment(value).format("DD/MM/YYYY")}</span>
        },
        { header: "Supplier Name", accessor: "name" },
        { header: "Email", accessor: "email" },
        { header: "Phone", accessor: "phone" },
        { header: "Address", accessor: "address" },
        {
            header: "Total Paid Amt", accessor: "total_paid",
            render: (value, row) => <span className="flex justify-end text-green-800 font-medium ">{value} BDT</span>
        },
        {
            header: "Purchases Due Amt", accessor: "purchase_due",
            render: (value, row) => <span className="flex justify-end text-red-600 font-medium">{value} BDT</span>
        },
    ];
    const columnsPayment = [
        {
            header: "Date", accessor: "created_at",
            render: (value, row) => <span>{moment(value).format("DD/MM/YYYY hh:mm:ss A")}</span>
        },
        { header: "Bank Name", accessor: "bank_name" },
        { header: "Description", accessor: "description" },
        {
            header: "Amount", accessor: "amount",
            render: (value, row) => <span className="flex justify-end text-green-800 font-medium ">{value} BDT</span>
        },
        {
            header: "Type", accessor: "type",
            render: (value, row) => <span>{capitalizeFirstLetter(value)}</span>
        },
    ];

    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <div className="w-full">
                <ExportButtons title="Suppliers List" onDownload={handleDownload} />
                <ResponsiveTable
                    columns={columns}
                    data={customersList}
                    showActions
                    actionButtons={actions}
                    onActionClick={handleActionClick}
                />
            </div>
            {/* Modal */}
            <Modal
                isOpen={isModalOpen}
                onClose={closeModal}
                header={<span className="text-blue-600">Payment History</span>}
                body={
                    <div className="h-[400px] my-3 overflow-auto">
                        <ResponsiveTable
                            columns={columnsPayment}
                            data={paymentList}
                            showActions={false}
                        />
                    </div>
                }
                footer={
                    <div className="flex gap-2">
                        <button
                            onClick={closeModal}
                            className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                        >
                            Close
                        </button>
                    </div>
                }
            />
        </div>
    );
}